import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React, { Component } from 'react';

import { signInWithLinkedIn } from '../../../core/actions';

import {
  Container,
  Loader,
  Logo,
  Text,
  Title,
  CenterText,
} from './styles';

class LinkedInCallback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      errorMessage: '',
      isLoading: true,
    };
  }

  async componentDidMount() {
    const { code, state } = queryString.parse(this.props.location.search);

    const { linkedIn, referral } = this.props;

    if (linkedIn.state !== state) {
      this.setState({
        error: true,
        isLoading: false,
      });

      return;
    }

    try {
      await this.props.signInWithLinkedIn(code, referral);
    } catch (err) {
      if (err.code === 'invalid_access_platform') {
        this.setState({
          error: true,
          isLoading: false,
          errorMessage: err?.message || 'Error',
        });
      } else {
        this.setState({
          error: true,
          isLoading: false,
        });
      }
    }
  }

  render() {
    const { error, isLoading, errorMessage } = this.state;

    if (isLoading) {
      return (
        <Container>
          <Logo
            src="/images/playbook-logo.png"
            alt="Playbook"
          />

          <Loader size="large" data-loader="linkedin-loader" />

          <Title>
            Authenticating with LinkedIn...
          </Title>
        </Container>
      );
    }

    if (error) {
      return (
        <Container>
          <Logo
            src="/images/playbook-logo.png"
            alt="Playbook"
          />
          {errorMessage && (
            <CenterText>
              <Text>
                {errorMessage}
                .
              </Text>
              <Text>
                Please contact our support.
              </Text>
            </CenterText>
          )}
          {!errorMessage && (
            <Text>
              Error while authenticating with LinkedIn. Please
              {' '}
              <Link to="/sign-in">try again</Link>
              .
            </Text>
          )}
        </Container>
      );
    }

    return null;
  }
}

LinkedInCallback.propTypes = {
  linkedIn: PropTypes.object.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  referral: PropTypes.string,
  signInWithLinkedIn: PropTypes.func.isRequired,
};

LinkedInCallback.defaultProps = {
  referral: null,
};

const mapStateToProps = ({ authentication }) => ({
  linkedIn: authentication.linkedIn,
  referral: authentication.referral,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  signInWithLinkedIn,
}, dispatch);

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(LinkedInCallback);
